<div
  *ngIf="isFormLoading"
  class="flex flex-col items-center justify-center p-12 min-h-[250px] w-full"
>
  <div
    class="animate-spin rounded-full h-10 w-10 border-4 border-gray-200 border-t-primary"
  ></div>
  <span class="text-sm text-gray-500 font-medium mt-3">Loading details...</span>
</div>

<form *ngIf="!isFormLoading && saveForm" [formGroup]="saveForm" autocomplete="off">
  <div
    class="mb-2 form-fields-grid"
    [class.no-padding]="hasFilterDropdown() || hasUserInvite()"
    [class.two-col-grid]="twoGridColumn"
    style="
      max-height: calc(100vh - 160px);
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #99a1b7 transparent;
    "
  >
    <!-- Permissions Note -->
    <div
      *ngIf="hasPermissions"
      class="col-span-full mb-3 px-2 bg-gray-50/80 dark:bg-coal-600/80 text-2sm text-gray-700 dark:text-gray-300"
    >
      <div class="flex items-start gap-2">
        <div class="flex flex-wrap items-center gap-1.5 grow">
          <ng-container>
            <span class="text-gray-600 font-medium text-xs">
              {{ formattedPermissions }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let field of formFields">
      <ng-container *ngIf="visibleFields[field.fieldName] !== false">
        <div
          [ngClass]="
            twoGridColumn &&
            (field.fieldName === 'domainSubdomainMappings' ||
              field.fieldName === 'framework' ||
              field.fieldName === 'frameworks')
              ? 'col-span-full'
              : twoGridColumn &&
                  field.fieldType !== 'textarea' &&
                  (field.componentId === 'inputTextField' ||
                    field.componentId === 'dropdownSelect' ||
                    field.componentId === 'dropdownWithSearch' ||
                    field.componentId === 'inputLabel' ||
                    field.componentId === 'radioButton' ||
                    field.componentId === 'phoneNumber' ||
                    field.componentId === 'switchField' ||
                    field.componentId === 'switchStatus')
                ? ''
                : twoGridColumn
                  ? 'col-span-full'
                  : ''
          "
        >
          <!-- <app-checkbox-with-text
            *ngIf="field.componentId == 'checkboxField'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-checkbox-with-text> -->
          <app-checkbox-text
            *ngIf="field.componentId == 'checkboxField'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-checkbox-text>
          <app-input-text-field
            *ngIf="field.componentId == 'inputTextField'"
            [formGroup]="saveForm"
            [fields]="field"
            [disableFields]="disableFields"
            [autoFocused]="field.fieldName === firstFocusFieldName"
            [labelAbove]="labelAbove"
            [dynamicRequired]="field.fieldName === 'comment' && commentRequired"
          ></app-input-text-field>
          <app-data-view-with-loader
            #DataViewWithLoaderComponent
            *ngIf="field.componentId == 'dataViewWithLoader'"
            [formGroup]="saveForm"
            [fields]="field"
            [sseConfig]="formData?.sseConfig"
            [formId]="formData?.formFields[0]?.formId"
            (loaderChange)="onLoaderChange($event)"
            (checkError)="checkError()"
          ></app-data-view-with-loader>
          <app-view-card
            *ngIf="field.componentId == 'viewCard'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-view-card>
          <!-- [sseConfig]="formData?.sseConfig"
            [formId]="formData?.formFields[0]?.formId" -->
          <app-domain-with-tags
            *ngIf="field.componentId == 'inputWithTags'"
            [formGroup]="saveForm"
            [fields]="field"
            [formData]="formData"
            [autoFocused]="field.fieldName === firstFocusFieldName"
            (submitRequested)="handleDomainSubmit()"
          ></app-domain-with-tags>
          <app-input-search-fields
            *ngIf="field.componentId == 'inputSearchField'"
            [formGroup]="saveForm"
            [fields]="field"
            [autoFocused]="field.fieldName === firstFocusFieldName"
          ></app-input-search-fields>
          <app-dropdown-select
            #dropdownSelect
            *ngIf="field.componentId == 'dropdownSelect'"
            [formGroup]="saveForm"
            [fields]="field"
            [labelAbove]="labelAbove"
            [showTags]="showTags"
            [autoFocused]="field.fieldName === firstFocusFieldName"
            [disableFields]="disableFields"
          ></app-dropdown-select>
          <app-placeholder-with-text
            *ngIf="field.componentId == 'noDataTypeOne'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
          ></app-placeholder-with-text>
          <app-checkbox-type-one
            *ngIf="field.componentId == 'checkboxTypeOne'"
            [formGroup]="saveForm"
            [fields]="field"
          >
          </app-checkbox-type-one>
          <app-checkbox-type-three
            *ngIf="field.componentId == 'checkboxTypeThree'"
            [formGroup]="saveForm"
            [fields]="field"
          >
          </app-checkbox-type-three>
          <app-projects-card
            *ngIf="field.componentId == 'projectsCard'"
            [formGroup]="saveForm"
            [fields]="field"
          >
          </app-projects-card>
          <app-search-with-input-data
            *ngIf="field.componentId == 'searchWithInputData'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-search-with-input-data>
          <app-label-type-two
            *ngIf="field.componentId == 'labelTypeOne'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
          ></app-label-type-two>
          <app-file-upload
            *ngIf="field.componentId == 'fileUploads'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-file-upload>
          <app-file-uploads
            *ngIf="field.componentId == 'fileUpload'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-file-uploads>
          <app-radio-buttons
            *ngIf="field.componentId == 'radioButton'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-radio-buttons>
          <app-domain-input
            *ngIf="field.componentId == 'domainInput'"
            [formGroup]="saveForm"
            [fields]="field"
            (apiValidationError)="hasDomainError = $event"
            [autoFocused]="true"
          ></app-domain-input>
          <app-dropdown-with-search
            #dropdownWithSearch
            *ngIf="field.componentId == 'dropdownWithSearch'"
            [formGroup]="saveForm"
            [fields]="field"
            [labelAbove]="labelAbove"
            [autoFocused]="field.fieldName === firstFocusFieldName"
            [twoGridColumn]="twoGridColumn"
            [disableFields]="disableFields"
          ></app-dropdown-with-search>
          <app-label-type-three
            *ngIf="field.componentId == 'labelTypeThree'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
          ></app-label-type-three>
          <app-reassignment-table
            *ngIf="field.componentId == 'reassignmentTable'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
          ></app-reassignment-table>
          <app-switch-field
            *ngIf="field.componentId == 'switchField'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
            [status]="activeModalContext?.status"
            [labelAbove]="labelAbove"
            [disableFields]="disableFields"
          ></app-switch-field>
          <app-search-list
            *ngIf="field.componentId == 'searchList'"
            [formGroup]="saveForm"
            [fields]="field"
            [autoFocused]="field.fieldName === firstFocusFieldName"
          ></app-search-list>
          <app-input-label
            *ngIf="field.componentId == 'inputLabel'"
            [formGroup]="saveForm"
            [fields]="field"
            [disableFields]="disableFields"
            [labelAbove]="labelAbove"
          ></app-input-label>
          <app-resources-card
            *ngIf="field.componentId == 'resourcesCard'"
            [formGroup]="saveForm"
            [fields]="field"
            [formID]="field?.formId"
            [currentSelectedName]="currentSelectedName"
          ></app-resources-card>
          <!-- [sseConfig]="formData?.sseConfig"
            [formId]="formData?.formFields[0]?.formId" -->
          <app-switch-status
            *ngIf="field.componentId == 'switchStatus'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
            [status]="activeModalContext?.status"
          ></app-switch-status>
          <app-access-view-card
            *ngIf="field.componentId == 'accessComponent'"
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
          ></app-access-view-card>
          <app-input-search-integration
            *ngIf="field.componentId == 'inputSearchIntegration'"
            [formGroup]="saveForm"
            [fields]="field"
            [autoFocused]="field.fieldName === firstFocusFieldName"
          ></app-input-search-integration>
          <app-phone-number
            *ngIf="field.componentId == 'phoneNumber'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-phone-number>
          <app-filter-dropdown
            *ngIf="
              field.componentId == 'filterDropdown' && isFirstFilterField(field)
            "
            [formGroup]="saveForm"
            [formFields]="formFields"
            [isEmbedded]="true"
            [formId]="nodeId || formData?.formFields?.[0]?.formId"
            (apply)="handleSubmit()"
            (clearAll)="onSave({ clickAction: 'clearAll' })"
          ></app-filter-dropdown>
          <app-input-with-checkbox
            *ngIf="field.componentId == 'inputWithCheckbox'"
            [formGroup]="saveForm"
            [fields]="field"
          ></app-input-with-checkbox>
          <app-user-invite
            *ngIf="field.componentId == 'userInvite'"
            [formGroup]="saveForm"
            [fields]="field"
            [organizationName]="profileResponse?.organizationName"
            (sendInvitation)="handleSendInvitation($event)"
            (closeModal)="closeModal.emit()"
          ></app-user-invite>
          <app-role-delete-impact
            *ngIf="
              field.componentId == 'roleDeleteImpact' ||
              field.componentId == 'roleImpactCard' ||
              field.componentId == 'deleteRoleImpact' ||
              field.componentId == 'roleImpact' ||
              field.componentId == 'roleDeleteWarning' ||
              field.componentId == 'deleteRole'
            "
            [formGroup]="saveForm"
            [fields]="field"
            [activeModalContext]="activeModalContext"
          ></app-role-delete-impact>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div
    *ngIf="isShowButton"
    class="modal-renderer-footer p-0 m-0 px-6 pt-2 pb-1 border-t border-gray-100 dark:border-gray-700"
  >
    <app-buttons
      (buttonClick)="onSave($event)"
      [btnFields]="footerFields"
      [isLoading]="isLoading"
      [isDisabled]="isDisabled"
      [formData]="formData"
    >
    </app-buttons>
  </div>
</form>
